<script setup lang="ts">
import DropdownItem from '#components/elements/dropdown/DropdownItem.vue';
import DropdownMenu from '#components/elements/dropdown/DropdownMenu.vue';
import { useLanguage } from '#composables/useLanguage';
import { type AvailableLanguagesType } from '@carrefour-gcs/shared';
import type { PropType } from 'vue';
import { computed } from 'vue';
import type { VariantType } from '../../elements/button';

const { t } = useLanguage();

const props = defineProps({
  value: {
    type: String as PropType<AvailableLanguagesType | undefined>,
    required: false,
    default: undefined
  },
  fullwidth: { type: Boolean, required: false, default: false },
  rounded: { type: Boolean, required: false, default: true },
  variant: { type: String as PropType<VariantType>, default: 'tertiary' }
});

const emit = defineEmits<{
  click: [lang: AvailableLanguagesType];
}>();

const { languages, language } = useLanguage();
const selectedLang = computed(() => props.value || language.value);
</script>

<template>
  <DropdownMenu :full-width="fullwidth" :rounded="rounded" :variant="variant" test-id="language-selector">
    <slot name="label">
      {{ t(`commonLabel.lang.${selectedLang}`) }}
    </slot>

    <template #items>
      <DropdownItem
        v-for="lang in languages"
        :key="lang"
        :test-id="`language-selector-${lang}`"
        @click="emit('click', lang)"
      >
        <div class="w-full text-center">
          <span v-if="selectedLang !== lang">{{ t(`commonLabel.lang.${lang}`) }}</span>
          <strong v-else>{{ t(`commonLabel.lang.${lang}`) }}</strong>
        </div>
      </DropdownItem>
    </template>
  </DropdownMenu>
</template>
